import { getSemiItem, getSemiProduceFactory, createSemiItem, setSemiItemProdrecipe, updateSemiItem } from '@/api/semiItem'
import Vue from 'vue'

const state = {
  semiItemList: [],
  totalCounts: 0,
}

const actions = {
  async getSemiItemAction({ commit }, payload) {
    try {
      const res = await getSemiItem(payload)
      commit('SET_SEMIITEMLIST', res.data)
      return res.data.semiItemList
    } catch (error) {
      throw error
    }
  },
  async getSemiProduceFactoryAction({ commit }, payload) {
    try {
      const res = await getSemiProduceFactory(payload)
      return res.data.semiItemList
    } catch (error) {
      throw error
    }
  },
  async createSemiItemAction({ commit }, payload) {
    try {
      const newSemiItem = await createSemiItem(payload);
      commit('ADD_NEW_SEMIITEM', newSemiItem.data)
    } catch (error) {
      throw error.message
    }
  },
  async setSemiItemProdrecipeAction({ commit }, payload) {
    try {
      const res = await setSemiItemProdrecipe(payload);
      return res.data.result
    } catch (error) {
      throw error.message
    }
  },

  async updateSemiItemAction({ commit }, payload) {
        try {
            const newSemiItem = await updateSemiItem(payload.id, payload.data)
            commit("UPDATE_SEMIITEM", newSemiItem.data)
            return newSemiItem.data
        } catch (error) {
            throw error.message
        }
    },

}

const mutations = {
  SET_SEMIITEMLIST(state, payload) {
    state.semiItemList = payload.semiItemList
    state.totalCounts = payload.totalCounts
  },
  ADD_NEW_SEMIITEM(state, semiItem){
    state.semiItemList.unshift(semiItem)
    state.totalCounts++
  },
  UPDATE_SEMIITEM(state, semiItem) {
    Vue.set(state.semiItemList, state.semiItemList.findIndex(x => x._id === semiItem._id), semiItem)
  },

}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}